import axios, { AxiosInstance } from 'axios';

const apiBaseURL: string = process.env.VUE_APP_API_BASE_URL || 'https://api.solucx.com.br/';

const instanceApiClient: AxiosInstance = axios.create({ baseURL: apiBaseURL });

export default instanceApiClient;
